import { translate } from '@/domains/core/localization/translate';
export const {
  topSaleLabel,
  selectionManomano,
  couponTag,
  secondHandLabel,
  blackFridayLabel,
  salesLabel,
  manomanoDaysLabel,
  proDaysLabel,
  loweredPriceLabel
} = {
  ...translate({
    "topSaleLabel": "Best sellers",
    "selectionManomano": "Mano selection",
    "couponTag": "offered",
    "secondHandLabel": "Seconde vie",
    "blackFridayLabel": "Black Friday",
    "salesLabel": "Sale",
    "manomanoDaysLabel": "ManoManoDays",
    "proDaysLabel": "ProDays",
    "loweredPriceLabel": "Price"
  })
};